import React from "react";
import MaterialIcon from "./MaterialIcon";

export const ICON_TONE_CLASSES = {
  primary: "bg-primary/10 text-primary",
  secondary: "bg-secondary/10 text-secondary",
  yellow: "bg-yellow-500/10 text-yellow-600",
  error: "bg-error/10 text-error",
  green: "bg-green-600/10 text-green-600",
};

/** 1 col mobile · 2 cols sm/md · max 4 cols lg/xl */
export const METRIC_STATS_GRID_CLASS =
  "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4";

const MetricStatCard = ({
  label,
  hint,
  value,
  icon,
  iconTone = "primary",
  borderClass = "border-primary",
  active = false,
  onClick,
  badge,
  badgeClass = "",
  className = "",
}) => {
  const toneClass = ICON_TONE_CLASSES[iconTone] ?? ICON_TONE_CLASSES.primary;
  const Component = onClick ? "button" : "div";

  return (
    <Component
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={[
        "tonal-card w-full rounded-xl border-l-4 p-stack-lg text-left transition-all",
        borderClass,
        active ? "ring-2 ring-secondary ring-offset-2" : "",
        onClick ? "cursor-pointer" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="flex flex-col gap-3 metric-card:flex-row metric-card:items-start metric-card:justify-between metric-card:gap-4">
        {icon ? (
          <div
            className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl metric-card:order-2 ${toneClass}`}
            aria-hidden
          >
            <MaterialIcon name={icon} className="text-[22px]" />
          </div>
        ) : null}

        <div className="min-w-0 flex-1 metric-card:order-1">
          <span className="mb-2 block font-label-caps uppercase text-on-surface-variant">
            {label}
          </span>
          <div className="flex flex-wrap items-baseline gap-2">
            {typeof value === "string" || typeof value === "number" ? (
              <span className="text-4xl font-bold tabular-nums">{value}</span>
            ) : (
              value
            )}
            {badge ? <span className={badgeClass}>{badge}</span> : null}
          </div>
          {hint ? (
            <p className="mt-2 text-[11px] leading-relaxed text-on-surface-variant">{hint}</p>
          ) : null}
        </div>
      </div>
    </Component>
  );
};

export default MetricStatCard;
